export default __webpack_public_path__ + "static/media/reference-files-dark.88de621a.svg";